import {
  isAtwDirectoryPagesPreviewHost,
  isAtwDirectoryPublicHost,
  PROD_DIRECTORY_HOST,
} from "@/lib/atwDirectoryHost";
import { atwAuthSigninUrl } from "@/lib/atwAuthHost";
import { atwDirectoryAppOrigin } from "@/lib/atwDirectoryHost";

export function apiOrigin(): string {
  const fromEnv = import.meta.env.VITE_API_BASE?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  if (typeof window !== "undefined") {
    const h = window.location.hostname.toLowerCase();
    if (isAtwDirectoryPagesPreviewHost(h) || (h.endsWith(".pages.dev") && h.includes("atw-directory"))) {
      return `https://${PROD_DIRECTORY_HOST}`;
    }
    if (isAtwDirectoryPublicHost(h)) {
      return window.location.origin.replace(/\/$/, "");
    }
  }
  return `https://${PROD_DIRECTORY_HOST}`;
}

export function apiFetchInit(): RequestInit {
  const origin = apiOrigin();
  const cross =
    typeof window !== "undefined" &&
    origin.replace(/\/$/, "") !== window.location.origin.replace(/\/$/, "");
  return cross ? { credentials: "include" } : { credentials: "same-origin" };
}

export function authSignInUrl(callbackPath: string): string {
  const path = callbackPath.startsWith("/") ? callbackPath : `/${callbackPath}`;
  const callback = `${atwDirectoryAppOrigin()}${path}`;
  return atwAuthSigninUrl(callback);
}

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${apiOrigin()}${p}`;
}
